import TumengVideo from './src/index.vue'

TumengVideo.install = function(Vue) {
  Vue.component(TumengVideo.name, TumengVideo)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengVideo)
}

export default TumengVideo
